/* api/index */ function _(require, module, exports) {
    var tslib_1 = require(400) /* tslib */;
    var LinAlg = require(404) /* ./linalg */;
    exports.LinAlg = LinAlg;
    var Charts = require(401) /* ./charts */;
    exports.Charts = Charts;
    var Plotting = require(408) /* ./plotting */;
    exports.Plotting = Plotting;
    var document_1 = require(54) /* ../document */;
    exports.Document = document_1.Document;
    var templating_1 = require(42) /* ../core/util/templating */;
    exports.sprintf = templating_1.sprintf;
    tslib_1.__exportStar(require(406) /* ./models */, exports);
}
